export default __webpack_public_path__ + "static/media/LEVEL2.0aa9104e.png";